<template>
  <div>
    <collection @sorting="sorting" @itemDelete="itemDelete" :loading="loading" :data="items" :structure="collectionData" :has_searched="has_searched" :params="params" model="workflow"></collection>
    <pagination @goToPage="goToPage" :page="page" :total-pages="total_pages"></pagination>
    <workflow-create/>
  </div>
</template>
<script>
import Api from '@/api/Workflow'
import Collection from '@/components/helpers/DataDisplay/Collection'
import { EventBus } from '@/EventBus.js'
import Ui from '@/classes/Ui'
import WorkflowCreate from './WorkflowCreate'
import {collectionMixin} from '@/components/mixins/Collection'

let structure = [
  { name: 'id', sortable: true, credentials: 'root' },
  { name: 'name', type: 'show_with_edit_link', title: 'Name', sortable: true },
  { name: 'status', sortable: true },
  { name: 'last_execution', type: 'date', time: true,  title: 'Last execution', sortable: true },
  { name: 'frequency', type: 'show', i18n: true, title: 'Frequency', sortable: true  },
  { name: 'daily_runtime', type: 'show', title: 'Daily runtime', sortable: true  },
  { name: 'final_run', type: 'date', time: true, title: 'Final run', sortable: true },
  { name: 'project.name', sortable: true, credentials: 'root', alias: 'project_name'},
  { name: 'action', type: 'crud_action_folded', credentials: 'admin' }
]

let default_sort_by = "id"
let default_sort_order = "DESC"
let default_filters = {}

export default {
  mixins: [collectionMixin],
  components: {
    WorkflowCreate,
    Collection
  },
  data() {
    return {
      loading: false,
      collectionData: structure,
      model: 'workflows',
      api: new Api(),
      title: 'ui.pages.workflows',
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_WORKFLOWS',
        routerName: 'workflows',
        emptyState: 'workflows',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    }
  },
  mounted() {
    EventBus.$off('workflow_duplicate')
    EventBus.$on('workflow_duplicate', this.duplicate)
    Ui.setHeaderButtons([
      { name: "workflow", action: "workflow.add_popup", classes: "btn-primary"}
    ])
  },
  methods: {
    async duplicate(payload) {
      let data = await this.api.duplicate(payload.id)
      let newWorkflow = data.resource
      let route = { name: 'workflow_edit', params: { id: newWorkflow.id }}
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Workflows.vue?79c4822c